
import { Component, Vue } from 'vue-property-decorator';
import { Client, IContactModel } from '@/services/api.service';

@Component({
    props: {
        contact: {
            type: Object as () => IContactModel,
            required: true
        }
    }
})
export default class ContactCard extends Vue {

}
